// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Belize from '../_raw/flag/icon_flag_belize.png';

export default () => <img src={Belize} alt="Belize" />;
